<script setup lang="ts">
import type { Component } from 'vue';
import BDialog from 'shared/components/base/BDialog/BDialog.vue';
import InfoDialogCard from 'shared/components/InfoDialogCard/InfoDialogCard.vue';
import type { TermsOfTransition } from 'types/course/termsOfTransition';

interface Props {
  /** The step kind's info card (useDrillComponents().infoComponent). */
  infoComponent: Component | null;
  instructions: string;
  drill: unknown;
  termsOfTransitions?: TermsOfTransition[] | undefined;
}

defineProps<Props>();

const emit = defineEmits<{ hide: [] }>();

const isOpen = defineModel<boolean>('isOpen', { default: false });
</script>

<template>
  <BDialog
    v-model:is-open="isOpen"
    position="bottom"
    card-class="bg-accent text-dark dialog-surface"
    title="INSTRUCTIONS"
    @hide="emit('hide')"
  >
    <InfoDialogCard>
      <component
        :is="infoComponent"
        :instructions="instructions"
        :drill="drill"
        :terms-of-transitions="termsOfTransitions"
      />
    </InfoDialogCard>
  </BDialog>
</template>
